import { _ } from "libs";
import React, { memo } from "react";
import Select from "../../select";
import { SelectValue } from "../../../types";

function createGenders(): SelectValue[] {
	return [
		{ value: "", label: "" },
		{ value: "F", label: _("gender.female") },
		{ value: "M", label: _("gender.male") },
	];
}

const GenderSelect = ({ input: { onChange, value, name }, prompt, ...rest }) => {
	const genders = createGenders();
	return (
		<div className="select gender">
			<Select prompt={prompt} items={genders} value={value} onChange={onChange} />
			<div className="icon" />
		</div>
	);
};

export default memo(GenderSelect);
